import { Controller } from "@hotwired/stimulus"

// Stops a "new tab" click (ctrl/cmd/shift-click, or middle-click) from
// bubbling past this element. Attach to a wrapper around links that should
// behave normally -- the browser still opens the new tab -- without
// triggering whatever window-level handler the click would otherwise reach
// (e.g. `click@window->dropdown#hide` closing a popover that should stay
// open, #4434).
//
// Bound to both "click" and "auxclick": modern browsers dispatch "auxclick",
// not "click", for middle-button presses (UI Events spec) -- `click` alone
// would miss middle-click entirely.
export default class extends Controller {
  guard(event) {
    const opensInNewTab = event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1

    if (opensInNewTab) {
      event.stopPropagation()
    }
  }
}
